export default "__VITE_ASSET__Lzyrw_77__"